import React, { useEffect } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import './assets/scss/main.scss';
// import './assets/css/main.css';
import WOW from 'wowjs';
import "bootstrap";

import HomeLayout from './layouts/HomeLayout';
import HomePage from "./pages/Home";

function App()
{
  useEffect(() =>
  {
    new WOW.WOW().init()
  }, [])

  return (
    <BrowserRouter>
      <div className="App">
        <Switch>
          <HomeLayout exact path="/" component={HomePage} />
        </Switch>
      </div>
    </BrowserRouter>
  );
}

export default App;
